import { IOfferState } from '../../types/reducers/offer';
import { isAreaPartsEmpty } from './isAreaPartsEmpty';

/** Определяет разделяемость объекта на части (опция «Можно частями») */
export const isObjectSplits = (offer: IOfferState): boolean => {
  return !isAreaPartsEmpty(offer);
};
